import React from 'react';
import { Link } from 'react-router-dom';
// import './style.scoped.scss';
import { FaBars } from 'react-icons/fa';
import { ROUTES } from '../../../assets/constants/strings';

const AccountLeftNav = ({ isUserAccount, activePage, navigationArray }) => {
  return (
    <React.Fragment>
      <div id='user-info-mobile'>
        <div className='dropdown'>
          <div
            id='my-account-dropdown'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            <FaBars />
          </div>
          <div className='dropdown-menu dropdown-menu-left p-0'>
            <div className='account-nav m-0'>
              {Object.values(navigationArray).map((item, i) => (
                <Link
                  to={
                    isUserAccount
                      ? ROUTES.APIAccountSettings + item.URL
                      : ROUTES.APIBilling + item.URL
                  }
                  key={i}
                  className={`account-nav__item${
                    activePage && activePage === item.URL ? ' active' : ''
                  }`}
                >
                  <span>{item.NAV}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className='account-nav' id='desktop-nav'>
        {Object.values(navigationArray).map((item, i) => (
          <Link
            to={
              isUserAccount
                ? ROUTES.APIAccountSettings + item.URL
                : ROUTES.APIBilling + item.URL
            }
            key={i}
            className={`account-nav__item${
              activePage && activePage === item.URL ? ' active' : ''
            } ${item.URL === 'deactivate-account' ? 'deactivate' : ''}`}
          >
            <span>{item.NAV}</span>
          </Link>
        ))}
      </div>
    </React.Fragment>
  );
};

export default AccountLeftNav;
